class ViewSwitch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleViewToggle = this.handleViewToggle.bind(this)

    this.els.toggle.elements.forEach((toggleEl) => {
      this.listeners.add(toggleEl, 'click', this.handleViewToggle)
    })
  }

  async handleViewToggle (e) {
    const viewTriggerEl = e.target.closest('[data-view-switch-el="toggle"]')

    if (!viewTriggerEl) return

    const viewportType = viewTriggerEl.dataset.viewport
    const currentView =
      viewportType === 'mobile'
        ? this.dataset.mobileView
        : this.dataset.desktopView
    const newView =
      viewportType === 'mobile'
        ? currentView === 'One'
          ? 'Two'
          : currentView === 'Two'
            ? 'Three'
            : 'One'
        : viewTriggerEl.dataset.view

    if (currentView === newView) return

    const mobileDisplayNext = newView === 'One' ? 2 : newView === 'Two' ? 3 : 1

    if (this.els.nextMobileView?.element) {
      this.els.nextMobileView.element.innerText = mobileDisplayNext
    }

    this.setAttribute(`data-${viewportType}-view`, newView)

    this.externalEls.grid.element.classList.replace(
      `clc-ProductGrid-${viewportType}${currentView}`,
      `clc-ProductGrid-${viewportType}${newView}`,
    )

    this.setButtonStates(viewportType, newView)

    if (viewportType === 'desktop') {
      await window.BAO.Cart.updateCartAttributes({
        desktop_view: newView,
      })
    } else {
      await window.BAO.Cart.updateCartAttributes({
        mobile_view: newView,
      })
    }

    try {
      const layoutValue = newView === 'One' ? 1 : newView === 'Two' ? 2 : 4

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'product_grid_view',
        productGridView: {
          url: document.location.pathname,
          view: layoutValue,
        },
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }

  setButtonStates (viewportType, newView) {
    this.els.toggle.elements.forEach((toggleEl) => {
      if (toggleEl.dataset.viewport === viewportType) {
        toggleEl.setAttribute(
          'aria-pressed',
          toggleEl.dataset.view === newView,
        )
      }
    })
  }
}

if (!customElements.get('view-switch')) {
  customElements.define('view-switch', ViewSwitch)
}
